import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className='footer'>
      <p>© 2024 Made by Shayon Keating</p>
      </div>
    </footer>
  );
}

export default Footer;
